import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import ErrorMessage from "../../../components/text/ErrorMessage";
import { FilterValue, FilterValueType } from "../../api";

export interface FilterProps<T = any> {
  filterKey: string;
  label: string;
  value?: FilterValueType<T>;
  applyFilter?: (value?: FilterValueType<T>) => void;
  resetFilter?: () => void;
  onClose?: () => void;
  fixed?: boolean;
  noContent?: boolean;
  feildOnePlaceholder?: string;
  feildTwoPlaceholder?: string;
  feildOneLabel: string;
  feildTwoLabel: string;
}

interface IFilterProps extends FilterProps {
  label: string;
  value?: FilterValue;
}

const MinMaxFilter: React.FunctionComponent<IFilterProps> = (props) => {
  const {
    handleSubmit,
    errors,
    watch,
    trigger,
    control,
    reset,
    setValue,
  } = useForm({
    defaultValues: {
      feildOne: props.value?.value?.startValue,
      feildTwo: props.value?.value?.endValue,
    },
  });
  const startRef = React.useRef<HTMLInputElement>(null);
  const endRef = React.useRef<HTMLInputElement>(null);

  const [startValue, setStartValue] = React.useState(0);
  const [endValue, setEndValue] = React.useState(0);

  const feildOne = watch("feildOne");
  const feildTwo = watch("feildTwo");

  useEffect(() => {
    trigger("feildOne");
    trigger("feildTwo");
  }, [watch("feildOne"), watch("feildTwo")]);

  const onClose = () => {
    setStartValue(0);
    setEndValue(0);
    // reset({ feildOne: '', feildTwo: '' })
    props.onClose?.();
  };

  React.useEffect(() => {
    setStartValue(props.value?.value?.startValue || 0);
    setEndValue(props.value?.value?.endValue || 0);
    setValue(
      "feildOne",
      props.value?.value?.startValue === 0 || props.value?.value?.startValue
        ? props.value?.value?.startValue
        : ""
    );
    setValue(
      "feildTwo",
      props.value?.value?.endValue === 0 || props.value?.value?.endValue
        ? props.value?.value?.endValue
        : props.value?.value?.endValue || ""
    );
  }, [props.value]);

  const onSubmit = () => {
    if (startRef?.current) {
      startRef.current.value = "";
    }
    if (endRef?.current) {
      endRef.current.value = "";
    }

    props.applyFilter?.({
      label: `${startValue ? startValue + " - " : ""}${endValue}`,
      value: { startValue, endValue },
    });
  };

  return (
    <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100  bg-white zIndex-1">
      <div className="d-flex align-items-center justify-content-between bg-primary px-3 py-2 text-white mb-3">
        <h6 className="m-0 font-xs font-weight-semibold">{props.label}</h6>
        <span
          className="cursor-pointer d-inline-block text-center rounded-circle sub-dropdown-back ml-3"
          onClick={onClose}
        >
          <i className="icon-close font-xxs"></i>
        </span>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="custom-dropdown__search  d-flex mb-2 position-sticky top-0 zIndex-1">
          <div className="row m-0">
            <div className="col-12 p-0">
              <Controller
                name="feildOne"
                control={control}
                rules={{
                  // required: "required",
                  validate: (value) => {
                    const numericfeildTwo = feildTwo;
                    if (
                      numericfeildTwo &&
                      (value === undefined || value === null || value === "")
                    ) {
                      return `${props?.feildOneLabel} is required`;
                    }
                    return undefined;
                  },
                }}
                defaultValue={props?.value?.value?.startValue}
                render={({ onChange, value, name }) => (
                  <input
                    type="number"
                    min={0}
                    value={value}
                    className="form-control border mb-3 py-0 px-1 font-weight-semibold font-normal"
                    placeholder={props.feildOnePlaceholder || ""}
                    onChange={(val) => {
                      onChange(val?.target?.value);
                      setStartValue(Number(val?.target?.value));
                    }}
                    ref={startRef}
                  />
                )}
              />
              {errors?.feildOne && (
                <ErrorMessage>{errors.feildOne.message}</ErrorMessage>
              )}
            </div>
            <div className="col-12 p-0">
              <Controller
                name="feildTwo"
                control={control}
                rules={{
                  // required: "required",
                  validate: (value) => {
                    const numericValue = value;
                    const tempfeildOne = feildOne;
                    return (tempfeildOne || tempfeildOne === 0) &&
                      numericValue !== 0 &&
                      !numericValue
                      ? `${props?.feildTwoLabel} is required`
                      : (!numericValue && numericValue !== 0) ||
                      (!tempfeildOne && tempfeildOne !== 0) ||
                      (numericValue &&
                        Number(numericValue) > Number(tempfeildOne)) ||
                      (numericValue === 0 && tempfeildOne === 0) ||
                      `${props?.feildTwoLabel} should be greater than ${props?.feildOneLabel}`;
                  },
                }}
                defaultValue={props?.value?.value?.endValue}
                render={({ onChange, value, name }) => (
                  <input
                    type="number"
                    min={0}
                    value={value}
                    className="form-control border py-0 px-1 font-weight-semibold font-normal"
                    placeholder={props.feildTwoPlaceholder || ""}
                    onChange={(val) => {
                      onChange(val?.target?.value);
                      setEndValue(Number(val?.target?.value));
                    }}
                    ref={endRef}
                  />
                )}
              />
              {errors?.feildTwo && (
                <ErrorMessage>{errors.feildTwo.message}</ErrorMessage>
              )}
            </div>
          </div>
        </div>
        <div className="px-3 text-right">
          <button
            type="submit"
            className="btn btn-primary py-2 px-4 font-weight-semibold"
          >
            <span className="px-2">Apply</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default MinMaxFilter;
